export default "__VITE_ASSET__Cqx84UA7__"